import { Button } from "@mui/material";
import { PersonAdd } from "@mui/icons-material";
import { makeStyles } from "components/providers/makeStyles";
import classNames from "classnames";

import { useDialogState } from "../../../hooks/useDialogState";
import { ResponsiveDialog } from "../../modal";
import { T } from "../../util/t";
import { AddEntryDialogContent } from "./AddEntryDialogContent";

const useDialogStyles = makeStyles(theme => ({
    dialog: {
        "& .MuiDialog-paper": {
            [theme.breakpoints.up("md")]: {
                height: window.innerHeight / 1.5
            }
        }
    }
}));

export const AddEntryWidget = ({ eventDivisionId, isTeams, registered, alternates }) => {
    const [dialogOpen, openDialog, closeDialog] = useDialogState({ disableBackdropClick: true });
    const classes = useDialogStyles();

    return (
        <>
            <Button onClick={openDialog} variant="outlined" size="small" startIcon={<PersonAdd fontSize="small"/>}>
                {isTeams ? <T>Add teams</T> : <T>Add athletes</T>}
            </Button>

            <ResponsiveDialog
                open={dialogOpen}
                fullWidth={true}
                maxWidth="sm"
                onClose={closeDialog}
                className={classNames("lh-dialog", classes.dialog)}
                aria-labelledby="add-athlete-dialog-title"
            >
                <AddEntryDialogContent
                    eventDivisionId={eventDivisionId}
                    isTeams={isTeams}
                    closeDialog={closeDialog}
                    registered={registered}
                    alternates={alternates}
                />
            </ResponsiveDialog>
        </>
    );
};
